(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["testimonios"] && !Shopify.designMode) return;
  try {
    

(function () {
  document.querySelectorAll('.testimonios-flora__seccion').forEach(function (seccion) {
    var track = seccion.querySelector('.testimonios-flora__track');
    var tarjetas = seccion.querySelectorAll('.testimonios-flora__tarjeta');
    var btnPrev = seccion.querySelector('.testimonios-flora__flecha--prev');
    var btnNext = seccion.querySelector('.testimonios-flora__flecha--next');
    var dotsContenedor = seccion.querySelector('.testimonios-flora__dots');

    if (!track || tarjetas.length === 0) return;

    var indiceActual = 0;

    function columnasPorVista() {
      if (window.innerWidth >= 990) return 3;
      if (window.innerWidth >= 749) return 2;
      return 1;
    }

    function totalPasos() {
      return Math.ceil(tarjetas.length / columnasPorVista());
    }

    function construirDots() {
      dotsContenedor.innerHTML = '';
      var total = totalPasos();
      for (var i = 0; i < total; i++) {
        var btn = document.createElement('button');
        btn.className = 'testimonios-flora__dot' + (i === indiceActual ? ' testimonios-flora__dot--activo' : '');
        btn.setAttribute('aria-label', 'Ir al grupo ' + (i + 1));
        btn.setAttribute('role', 'tab');
        (function (idx) {
          btn.addEventListener('click', function () { irA(idx); });
        })(i);
        dotsContenedor.appendChild(btn);
      }
    }

    function actualizarDots() {
      var dots = dotsContenedor.querySelectorAll('.testimonios-flora__dot');
      dots.forEach(function (d, i) {
        d.classList.toggle('testimonios-flora__dot--activo', i === indiceActual);
      });
    }

    function irA(idx) {
      var total = totalPasos();
      indiceActual = Math.max(0, Math.min(idx, total - 1));
      var cols = columnasPorVista();
      var gap = 20;
      var anchoTarjeta = tarjetas[0].offsetWidth;
      var desplazamiento = indiceActual * cols * (anchoTarjeta + gap);
      track.style.transform = 'translateX(-' + desplazamiento + 'px)';
      actualizarDots();
    }

    btnPrev.addEventListener('click', function () { irA(indiceActual - 1); });
    btnNext.addEventListener('click', function () { irA(indiceActual + 1); });

    var resizeTimer;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () {
        indiceActual = 0;
        construirDots();
        irA(0);
      }, 150);
    });

    construirDots();
    irA(0);
  });
})();


  } catch(e) { console.error(e); }
})();
})();
